// Static master list of Indian cities for the college filter's City autosuggest
// (CollegeFilterSidebar.js). The DB-backed /api/v1/college/cities list only knows cities that
// already have a college on file, so a student searching from e.g. Itanagar or Gangtok saw
// nothing to pick. This list is merged with the DB list, never replaces it.
//
// Covers every state/UT capital, all major cities and district headquarters, and the towns
// that commonly host colleges. Common older spellings (Bangalore, Calicut, Allahabad ...) are
// listed next to the current official names on purpose: the college data itself mixes both
// (e.g. 218 colleges say "Bangalore", 11 say "Bengaluru") and the filter is a substring match
// on whatever spelling is picked.

const CITIES_BY_REGION = {
  "Andhra Pradesh": [
    "Visakhapatnam", "Vizag", "Vijayawada", "Guntur", "Nellore", "Kurnool", "Rajahmundry", "Kakinada",
    "Tirupati", "Kadapa", "Anantapur", "Eluru", "Ongole", "Chittoor", "Machilipatnam", "Tenali",
    "Proddatur", "Adoni", "Madanapalle", "Srikakulam", "Hindupur", "Vizianagaram", "Bhimavaram",
    "Dharmavaram", "Gudivada", "Narasaraopet", "Tadipatri", "Tadepalligudem", "Chilakaluripet",
    "Amaravati", "Nandyal", "Palakollu", "Tuni", "Mangalagiri", "Ponnur", "Bapatla", "Markapur",
    "Gooty", "Nandigama", "Pithapuram", "Puttur", "Srikalahasti", "Kavali", "Sullurpeta", "Bobbili",
    "Anakapalle", "Narsipatnam", "Amalapuram", "Ramachandrapuram", "Mandapeta", "Peddapuram",
    "Jangareddygudem", "Nuzvid", "Kovvur", "Nidadavole", "Tanuku", "Chirala", "Palasa", "Rajam",
    "Kadiri", "Penukonda", "Puttaparthi", "Guntakal", "Rayadurg", "Pulivendula", "Yemmiganur",
    "Dhone", "Jammalamadugu", "Badvel", "Gajuwaka", "Parvathipuram", "Salur", "Tirumala", "Venkatagiri",
  ],
  "Arunachal Pradesh": [
    "Itanagar", "Naharlagun", "Pasighat", "Tawang", "Ziro", "Bomdila", "Tezu", "Along", "Roing",
    "Namsai", "Changlang", "Khonsa", "Yingkiong", "Daporijo", "Seppa",
  ],
  "Assam": [
    "Guwahati", "Gauhati", "Dispur", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tinsukia", "Tezpur",
    "Bongaigaon", "Dhubri", "Diphu", "North Lakhimpur", "Karimganj", "Sivasagar", "Goalpara",
    "Barpeta", "Mangaldoi", "Nalbari", "Rangia", "Margherita", "Golaghat", "Haflong", "Kokrajhar",
    "Hailakandi", "Dhemaji", "Digboi", "Duliajan", "Morigaon", "Biswanath Chariali", "Hojai",
    "Lumding", "Sonari", "Abhayapuri", "Bilasipara", "Mariani", "Doom Dooma", "Darrang",
  ],
  "Bihar": [
    "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia", "Darbhanga", "Bihar Sharif", "Arrah",
    "Begusarai", "Katihar", "Munger", "Chhapra", "Danapur", "Bettiah", "Saharsa", "Sasaram", "Hajipur",
    "Dehri", "Siwan", "Motihari", "Nawada", "Bagaha", "Buxar", "Kishanganj", "Sitamarhi", "Jamalpur",
    "Jehanabad", "Aurangabad (Bihar)", "Lakhisarai", "Madhubani", "Samastipur", "Araria", "Supaul",
    "Forbesganj", "Raxaul", "Bhabua", "Jamui", "Sheohar", "Khagaria", "Banka", "Gopalganj", "Mokama",
    "Barh", "Masaurhi", "Phulwari Sharif", "Sherghati", "Naugachhia", "Sultanganj", "Dumraon",
    "Bodh Gaya", "Rajgir", "Nalanda", "Vaishali", "Kaimur", "Rohtas", "Sheikhpura", "Madhepura",
  ],
  "Chhattisgarh": [
    "Raipur", "Bhilai", "Bilaspur (Chhattisgarh)", "Korba", "Durg", "Rajnandgaon", "Raigarh",
    "Jagdalpur", "Ambikapur", "Chirmiri", "Dhamtari", "Mahasamund", "Kawardha", "Kanker", "Bhatapara",
    "Naya Raipur", "Dalli-Rajhara", "Champa", "Janjgir", "Mungeli", "Bemetara", "Kondagaon",
    "Dantewada", "Jashpur Nagar", "Akaltara", "Balod", "Baloda Bazar", "Bijapur (Chhattisgarh)",
  ],
  "Goa": [
    "Panaji", "Panjim", "Margao", "Vasco da Gama", "Mapusa", "Ponda", "Bicholim", "Curchorem",
    "Sanquelim", "Cuncolim", "Valpoi", "Canacona", "Quepem", "Pernem", "Sanguem", "Mormugao",
    "Calangute", "Candolim", "Anjuna", "Old Goa",
  ],
  "Gujarat": [
    "Ahmedabad", "Surat", "Vadodara", "Baroda", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh",
    "Gandhinagar", "Gandhidham", "Anand", "Vallabh Vidyanagar", "Navsari", "Morbi", "Nadiad",
    "Surendranagar", "Bharuch", "Mehsana", "Bhuj", "Porbandar", "Palanpur", "Valsad", "Vapi", "Gondal",
    "Veraval", "Godhra", "Patan (Gujarat)", "Kalol", "Dahod", "Botad", "Amreli", "Deesa", "Jetpur",
    "Ankleshwar", "Himmatnagar", "Mansa", "Idar", "Unjha", "Visnagar", "Dholka", "Sanand", "Bardoli",
    "Vyara", "Modasa", "Palitana", "Mahuva", "Dhoraji", "Upleta", "Wankaner", "Halol", "Kadi",
    "Viramgam", "Dhrangadhra", "Limbdi", "Savarkundla", "Una", "Kodinar", "Keshod", "Dwarka", "Okha",
    "Khambhat", "Petlad", "Padra", "Dabhoi", "Waghodia", "Jambusar", "Mandvi", "Bilimora", "Gandevi",
    "Chikhli", "Pardi", "Umbergaon", "Sidhpur", "Radhanpur", "Dhanera", "Lunawada", "Mundra", "Anjar",
    "Bhachau", "Rapar", "Sihor", "Talaja", "Rajula", "Dahej", "Sachin", "Kamrej", "Palsana",
  ],
  "Haryana": [
    "Faridabad", "Gurugram", "Gurgaon", "Panipat", "Ambala", "Yamunanagar", "Rohtak", "Hisar", "Karnal",
    "Sonipat", "Panchkula", "Bhiwani", "Sirsa", "Bahadurgarh", "Jind", "Thanesar", "Kurukshetra",
    "Kaithal", "Rewari", "Narnaul", "Pundri", "Kosli", "Palwal", "Hansi", "Mahendragarh", "Fatehabad",
    "Gohana", "Tohana", "Narwana", "Mandi Dabwali", "Charkhi Dadri", "Shahbad", "Pehowa", "Samalkha",
    "Nuh", "Ladwa", "Jhajjar", "Ellenabad", "Barwala", "Ratia", "Hodal", "Ganaur", "Assandh", "Radaur",
    "Rania", "Manesar", "Sohna", "Bawal", "Dharuhera", "Bhiwadi",
  ],
  "Himachal Pradesh": [
    "Shimla", "Solan", "Mandi", "Dharamshala", "Baddi", "Nahan", "Palampur", "Kullu", "Manali",
    "Hamirpur (Himachal Pradesh)", "Bilaspur (Himachal Pradesh)", "Una", "Chamba", "Kangra",
    "Sundernagar", "Paonta Sahib", "Nurpur", "Rampur", "Parwanoo", "Nalagarh", "Dalhousie", "Kasauli",
    "Keylong", "Reckong Peo", "Jawalamukhi", "Jogindernagar", "Theog", "Rohru", "Arki", "Kufri",
    "Narkanda", "Dehra", "Nagrota Bagwan", "Sarkaghat", "Kasol", "McLeod Ganj",
  ],
  "Jammu & Kashmir": [
    "Srinagar", "Jammu", "Anantnag", "Baramulla", "Sopore", "Kathua", "Udhampur", "Punch", "Rajouri",
    "Kupwara", "Pulwama", "Budgam", "Bandipora", "Ganderbal", "Kulgam", "Shopian", "Samba", "Doda",
    "Kishtwar", "Ramban", "Reasi", "Akhnoor", "Bari Brahmana", "Katra", "Vijaypur", "Awantipora",
    "Pahalgam", "Gulmarg", "Sonamarg", "Bhaderwah", "Nowshera",
  ],
  "Jharkhand": [
    "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro Steel City", "Bokaro", "Deoghar", "Phusro", "Hazaribagh",
    "Giridih", "Ramgarh", "Medininagar", "Daltonganj", "Chirkunda", "Jhumri Telaiya", "Sahibganj",
    "Madhupur", "Adityapur", "Chaibasa", "Godda", "Lohardaga", "Dumka", "Pakur", "Chatra", "Gumla",
    "Koderma", "Simdega", "Khunti", "Jamtara", "Barhi", "Mihijam", "Chas", "Sindri", "Gomoh",
    "Chakradharpur", "Latehar", "Patratu", "Kandra", "Mango", "Gamharia",
  ],
  "Karnataka": [
    "Bengaluru", "Bangalore", "Mysuru", "Mysore", "Hubballi", "Hubli", "Dharwad", "Hubballi-Dharwad",
    "Mangaluru", "Mangalore", "Belagavi", "Belgaum", "Kalaburagi", "Gulbarga", "Davanagere",
    "Ballari", "Bellary", "Vijayapura", "Bijapur (Karnataka)", "Shivamogga", "Shimoga", "Tumakuru",
    "Tumkur", "Raichur", "Bidar", "Hosapete", "Hospet", "Gadag", "Hassan", "Udupi", "Manipal",
    "Chitradurga", "Mandya", "Kolar", "Chikkamagaluru", "Chikmagalur", "Chikkaballapur", "Bagalkot",
    "Ramanagara", "Karwar", "Koppal", "Haveri", "Madikeri", "Gangavathi", "Bhadravati",
    "Ranebennur", "Sirsi", "Gokak", "Puttur (Karnataka)", "Sagara", "Nipani", "Saundatti", "Athani",
    "Ilkal", "Yadgir", "Sindhanur", "Gundlupet", "Chamarajanagar", "Doddaballapur", "Channapatna",
    "Surathkal", "Moodbidri", "Kundapura", "Karkala", "Bantwal", "Sullia", "Dandeli", "Bhatkal",
    "Kumta", "Honnavar", "Ankola", "Harihar", "Hiriyur", "Tiptur", "Sira", "Pavagada", "Madhugiri",
    "Kunigal", "Nelamangala", "Devanahalli", "Anekal", "Hoskote", "Malur", "Bangarapet",
    "Kolar Gold Fields", "Chintamani", "Shidlaghatta", "Gauribidanur", "Bagepalli", "Krishnarajanagara",
    "Nanjangud", "Hunsur", "Periyapatna", "Kollegal", "Mudhol", "Jamkhandi", "Badami", "Hungund",
    "Ramdurg", "Bailhongal", "Chikodi", "Raibag", "Mudalgi", "Kudligi", "Hagaribommanahalli",
  ],
  "Kerala": [
    "Thiruvananthapuram", "Trivandrum", "Kochi", "Cochin", "Kozhikode", "Calicut", "Kollam", "Quilon",
    "Thrissur", "Trichur", "Alappuzha", "Alleppey", "Palakkad", "Palghat", "Malappuram", "Kannur",
    "Cannanore", "Kasaragod", "Kottayam", "Pathanamthitta", "Idukki", "Wayanad", "Ernakulam",
    "Kalamassery", "Thalassery", "Kayamkulam", "Neyyattinkara", "Payyannur", "Manjeri", "Tirur",
    "Kanhangad", "Taliparamba", "Vatakara", "Koyilandy", "Perinthalmanna", "Chalakudy",
    "Changanassery", "Irinjalakuda", "Muvattupuzha", "Attingal", "Nedumangad", "Varkala", "Punalur",
    "Adoor", "Thodupuzha", "Kothamangalam", "Aluva", "Angamaly", "Perumbavoor", "Guruvayur",
    "Kunnamkulam", "Ponnani", "Nilambur", "Mattannur", "Sulthan Bathery", "Kalpetta", "Mananthavady",
    "Pala", "Ettumanoor", "Cherthala", "Mavelikara", "Chengannur", "Thiruvalla", "Kattappana", "Munnar",
    "Thrippunithura", "Shornur", "Ottappalam", "Pattambi", "Mannarkkad", "Kodungallur", "Koothattukulam",
    "Kanjirappally", "Vaikom", "Iritty", "Chavakkad", "Edappal", "Kondotty", "Valanchery", "Tanur",
    "Parappanangadi", "Kovalam", "Thekkady", "Kumarakom", "Varapuzha", "Kakkanad", "Edappally",
  ],
  "Madhya Pradesh": [
    "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna", "Ratlam", "Rewa",
    "Katni", "Murwara", "Singrauli", "Burhanpur", "Khandwa", "Bhind", "Chhindwara", "Guna", "Shivpuri",
    "Vidisha", "Chhatarpur", "Damoh", "Mandsaur", "Khargone", "Neemuch", "Pithampur", "Hoshangabad",
    "Narmadapuram", "Itarsi", "Sehore", "Morena", "Betul", "Seoni", "Datia", "Nagda", "Panna", "Dhar",
    "Balaghat", "Shahdol", "Mhow", "Sidhi", "Tikamgarh", "Ashok Nagar", "Mandla", "Harda", "Barwani",
    "Alirajpur", "Jhabua", "Shajapur", "Rajgarh", "Raisen", "Sendhwa", "Dindori", "Umaria", "Anuppur",
    "Maihar", "Bina", "Ganj Basoda", "Sanawad", "Pachmarhi", "Khajuraho", "Omkareshwar", "Amla",
    "Pandhurna", "Multai", "Gadarwara", "Narsinghpur", "Sarni", "Maheshwar", "Mandleshwar",
  ],
  "Maharashtra": [
    "Mumbai", "Bombay", "Pune", "Poona", "Nagpur", "Thane", "Nashik", "Aurangabad (Maharashtra)",
    "Chhatrapati Sambhajinagar", "Solapur", "Navi Mumbai", "Kalyan", "Dombivli", "Vasai-Virar", "Vasai",
    "Virar", "Mira-Bhayandar", "Bhiwandi", "Ulhasnagar", "Ambernath", "Badlapur", "Kolhapur", "Sangli",
    "Miraj", "Malegaon", "Jalgaon", "Akola", "Latur", "Dhule", "Ahmednagar", "Ahilyanagar", "Chandrapur",
    "Parbhani", "Ichalkaranji", "Jalna", "Bhusawal", "Panvel", "Satara", "Beed", "Yavatmal", "Kamptee",
    "Gondia", "Achalpur", "Osmanabad", "Dharashiv", "Nanded", "Wardha", "Udgir", "Amravati",
    "Hinganghat", "Pimpri-Chinchwad", "Pimpri", "Chinchwad", "Karad", "Ratnagiri", "Alibag", "Lonavala",
    "Khopoli", "Pen", "Mahad", "Chiplun", "Kudal", "Sawantwadi", "Malvan", "Shirdi", "Sangamner",
    "Kopargaon", "Shrirampur", "Rahuri", "Baramati", "Daund", "Talegaon Dabhade", "Shirur", "Junnar",
    "Pandharpur", "Barshi", "Akkalkot", "Islampur", "Vita", "Tasgaon", "Gadhinglaj", "Kagal", "Wai",
    "Mahabaleshwar", "Panchgani", "Phaltan", "Nandurbar", "Shahada", "Shirpur", "Chalisgaon",
    "Amalner", "Pachora", "Sillod", "Paithan", "Vaijapur", "Kannad", "Hingoli", "Washim", "Karanja",
    "Pusad", "Digras", "Umarkhed", "Wani", "Arvi", "Pulgaon", "Bhandara", "Tumsar", "Gadchiroli",
    "Brahmapuri", "Warora", "Bhadravati (Maharashtra)", "Rajura", "Ballarpur", "Umred", "Katol",
    "Saoner", "Ramtek", "Khamgaon", "Shegaon", "Malkapur", "Buldhana", "Chikhli (Maharashtra)",
    "Mehkar", "Gangakhed", "Ambajogai", "Parli", "Ausa", "Nilanga", "Ahmedpur", "Omerga", "Tuljapur",
    "Karjat", "Jamkhed", "Lonar", "Deolali", "Dehu Road", "Alandi", "Chakan", "Hinjewadi", "Wagholi",
    "Kharghar", "Airoli", "Vashi", "Belapur", "Nerul", "Taloja", "Boisar", "Palghar", "Dahanu",
    "Kankavli", "Sindhudurg", "Matheran", "Neral", "Ozar", "Sinnar", "Igatpuri", "Manmad", "Yeola",
  ],
  "Manipur": [
    "Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching", "Ukhrul", "Senapati", "Tamenglong",
    "Jiribam", "Moirang", "Lilong", "Mayang Imphal", "Nambol", "Wangjing",
  ],
  "Meghalaya": [
    "Shillong", "Tura", "Jowai", "Nongstoin", "Baghmara", "Williamnagar", "Nongpoh", "Mawlai",
    "Cherrapunji", "Sohra", "Resubelpara", "Khliehriat", "Mairang",
  ],
  "Mizoram": [
    "Aizawl", "Lunglei", "Champhai", "Serchhip", "Kolasib", "Saiha", "Lawngtlai", "Mamit",
  ],
  "Nagaland": [
    "Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha", "Zunheboto", "Phek", "Mon", "Kiphire",
    "Longleng", "Peren", "Chumoukedima",
  ],
  "Odisha": [
    "Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Brahmapur", "Sambalpur", "Puri", "Balasore",
    "Bhadrak", "Baripada", "Jharsuguda", "Jeypore", "Barbil", "Khordha", "Angul", "Dhenkanal",
    "Keonjhar", "Kendujhar", "Koraput", "Rayagada", "Bargarh", "Paradip", "Talcher", "Sunabeda",
    "Balangir", "Bolangir", "Kendrapara", "Jagatsinghpur", "Phulbani", "Nabarangpur", "Malkangiri",
    "Sonepur", "Bhawanipatna", "Titlagarh", "Belpahar", "Brajrajnagar", "Konark", "Gunupur",
    "Parlakhemundi", "Joda", "Rairangpur", "Nayagarh", "Jajpur", "Chhatrapur", "Sundargarh", "Deogarh",
    "Hinjilicut", "Aska", "Burla", "Bhubaneshwar", "Rambha", "Chandipur",
  ],
  "Punjab": [
    "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali", "SAS Nagar", "Hoshiarpur",
    "Batala", "Pathankot", "Moga", "Abohar", "Malerkotla", "Khanna", "Phagwara", "Muktsar", "Barnala",
    "Firozpur", "Ferozepur", "Kapurthala", "Zirakpur", "Rajpura", "Sangrur", "Faridkot", "Fazilka",
    "Gurdaspur", "Kharar", "Mandi Gobindgarh", "Mansa", "Malout", "Nabha", "Tarn Taran", "Jagraon",
    "Dera Bassi", "Rupnagar", "Ropar", "Nawanshahr", "Samana", "Sunam", "Dhuri", "Morinda", "Longowal",
    "Anandpur Sahib", "Fatehgarh Sahib", "Banga", "Mukerian", "Dasuya", "Nakodar", "Sultanpur Lodhi",
    "Zira", "Talwandi Sabo", "Lalru", "Goraya", "Bhawanigarh",
  ],
  "Rajasthan": [
    "Jaipur", "Jodhpur", "Kota", "Bikaner", "Ajmer", "Udaipur", "Bhilwara", "Alwar", "Bharatpur",
    "Sikar", "Pali", "Sri Ganganagar", "Kishangarh", "Beawar", "Tonk", "Hanumangarh", "Churu",
    "Jhunjhunu", "Barmer", "Chittorgarh", "Dausa", "Sawai Madhopur", "Banswara", "Baran", "Bundi",
    "Dholpur", "Dungarpur", "Jaisalmer", "Jalore", "Jhalawar", "Karauli", "Nagaur", "Pratapgarh (Rajasthan)",
    "Rajsamand", "Sirohi", "Mount Abu", "Pushkar", "Neemrana", "Abu Road", "Sujangarh", "Ratangarh",
    "Fatehpur Shekhawati", "Nokha", "Sumerpur", "Phalodi", "Makrana", "Merta City", "Didwana", "Ladnun",
    "Lalsot", "Gangapur City", "Hindaun", "Nathdwara", "Nasirabad", "Suratgarh", "Raisinghnagar",
    "Pilani", "Kekri", "Sardarshahar", "Bhadra", "Bhinmal", "Bundi", "Chomu", "Shahpura", "Sambhar",
  ],
  "Sikkim": [
    "Gangtok", "Namchi", "Gyalshing", "Geyzing", "Mangan", "Rangpo", "Jorethang", "Singtam", "Ravangla",
    "Pelling", "Soreng",
  ],
  "Tamil Nadu": [
    "Chennai", "Madras", "Coimbatore", "Madurai", "Tiruchirappalli", "Trichy", "Salem", "Tirunelveli",
    "Tiruppur", "Vellore", "Erode", "Thoothukudi", "Tuticorin", "Dindigul", "Thanjavur", "Ranipet",
    "Sivakasi", "Karur", "Udhagamandalam", "Ooty", "Hosur", "Nagercoil", "Kanchipuram", "Kancheepuram",
    "Kumbakonam", "Rajapalayam", "Pudukkottai", "Ambur", "Nagapattinam", "Cuddalore", "Tiruvannamalai",
    "Avadi", "Tambaram", "Pallavaram", "Thiruvottiyur", "Krishnagiri", "Dharmapuri", "Namakkal",
    "Perambalur", "Ariyalur", "Villupuram", "Kallakurichi", "Tenkasi", "Virudhunagar", "Sivaganga",
    "Karaikudi", "Ramanathapuram", "Theni", "Tirupattur", "Tiruvallur", "Tiruvarur", "Mayiladuthurai",
    "Chengalpattu", "Pollachi", "Mettupalayam", "Gobichettipalayam", "Bhavani", "Sathyamangalam",
    "Palani", "Kodaikanal", "Coonoor", "Kotagiri", "Valparai", "Udumalaipettai", "Tiruchengode",
    "Rasipuram", "Mettur", "Attur", "Vaniyambadi", "Arakkonam", "Walajapet", "Arcot", "Gudiyatham",
    "Chidambaram", "Vriddhachalam", "Neyveli", "Panruti", "Tindivanam", "Mahabalipuram",
    "Maraimalai Nagar", "Sriperumbudur", "Poonamallee", "Ponneri", "Gummidipoondi", "Thiruvallur",
    "Srirangam", "Lalgudi", "Musiri", "Thuraiyur", "Manapparai", "Aruppukkottai", "Srivilliputhur",
    "Sattur", "Kovilpatti", "Tiruchendur", "Nanguneri", "Valliyur", "Thuckalay", "Marthandam",
    "Kuzhithurai", "Colachel", "Devakottai", "Paramakudi", "Rameswaram", "Mannargudi", "Pattukkottai",
    "Sirkazhi", "Kovai", "Sholinganallur", "Perungudi", "Chromepet", "Guindy", "Anna Nagar", "Ambattur",
    "Padappai", "Oragadam", "Kelambakkam", "Siruseri", "Namakkal", "Dharapuram", "Kangeyam", "Avinashi",
  ],
  "Telangana": [
    "Hyderabad", "Secunderabad", "Warangal", "Hanamkonda", "Nizamabad", "Karimnagar", "Khammam",
    "Ramagundam", "Mahbubnagar", "Mahabubnagar", "Nalgonda", "Adilabad", "Suryapet", "Miryalaguda",
    "Siddipet", "Mancherial", "Jagtial", "Kamareddy", "Sangareddy", "Medak", "Vikarabad", "Bhongir",
    "Kothagudem", "Nirmal", "Wanaparthy", "Gadwal", "Nagarkurnool", "Mahabubabad", "Jangaon",
    "Peddapalli", "Sircilla", "Kagaznagar", "Bodhan", "Armoor", "Zaheerabad", "Narayanpet", "Tandur",
    "Bellampalli", "Medchal", "Shamshabad", "Patancheru", "Ibrahimpatnam", "Kukatpally", "Uppal",
    "Ghatkesar", "Hayathnagar", "Pochampally", "Husnabad", "Huzurabad", "Jammikunta", "Metpally",
    "Koratla", "Vemulawada", "Manthani", "Godavarikhani", "Yellandu", "Palwancha", "Madhira",
    "Sathupalli", "Kodad", "Huzurnagar", "Devarakonda", "Shadnagar", "Gajwel", "Maheshwaram",
    "Hitec City", "Gachibowli", "Madhapur", "Kondapur", "Miyapur", "Bachupally", "Nizampet", "LB Nagar",
  ],
  "Tripura": [
    "Agartala", "Udaipur (Tripura)", "Dharmanagar", "Kailasahar", "Belonia", "Khowai", "Ambassa",
    "Teliamura", "Sabroom", "Sonamura", "Bishalgarh", "Melaghar", "Kamalpur", "Santirbazar",
  ],
  "Uttar Pradesh": [
    "Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Banaras", "Benares", "Meerut", "Prayagraj",
    "Allahabad", "Bareilly", "Aligarh", "Moradabad", "Saharanpur", "Gorakhpur", "Faizabad", "Ayodhya",
    "Firozabad", "Jhansi", "Muzaffarnagar", "Mathura", "Vrindavan", "Budaun", "Rampur", "Shahjahanpur",
    "Farrukhabad", "Mau", "Hapur", "Etawah", "Mirzapur", "Bulandshahr", "Sambhal", "Amroha", "Hardoi",
    "Fatehpur", "Raebareli", "Orai", "Sitapur", "Bahraich", "Modinagar", "Unnao", "Jaunpur",
    "Lakhimpur", "Hathras", "Banda", "Pilibhit", "Barabanki", "Mughalsarai", "Khurja", "Gonda",
    "Mainpuri", "Lalitpur", "Etah", "Deoria", "Ghazipur", "Sultanpur", "Azamgarh", "Bijnor",
    "Sahaswan", "Basti", "Chandausi", "Akbarpur", "Ballia", "Tanda", "Greater Noida", "Noida",
    "Shikohabad", "Shamli", "Baraut", "Auraiya", "Kasganj", "Kairana", "Deoband", "Sikandrabad",
    "Dadri", "Kushinagar", "Maharajganj", "Siddharthnagar", "Balrampur", "Shravasti", "Chandauli",
    "Sonbhadra", "Robertsganj", "Mahoba", "Chitrakoot", "Karwi", "Kannauj", "Chhibramau", "Hamirpur (Uttar Pradesh)",
    "Kaushambi", "Pratapgarh (Uttar Pradesh)", "Amethi", "Gauriganj", "Bhadohi", "Gautam Buddha Nagar",
    "Sant Kabir Nagar", "Ambedkar Nagar", "Jalaun", "Kanpur Dehat", "Muzaffarnagar", "Bagpat",
    "Baghpat", "Sandila", "Mohanlalganj", "Bijnor", "Najibabad", "Nagina", "Dhampur", "Kanth",
    "Jahangirabad", "Gajraula", "Mirzapur", "Vindhyachal", "Sarnath", "Naini", "Phulpur",
  ],
  "Uttarakhand": [
    "Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur", "Kashipur", "Rishikesh", "Kotdwar",
    "Ramnagar", "Pithoragarh", "Jaspur", "Manglaur", "Nainital", "Mussoorie", "Almora", "Pauri",
    "Tehri", "Srinagar (Uttarakhand)", "Bageshwar", "Champawat", "Uttarkashi", "Gopeshwar",
    "Rudraprayag", "Lansdowne", "Vikasnagar", "Herbertpur", "Sitarganj", "Kichha", "Bazpur",
    "Tanakpur", "Ranikhet", "Bhimtal", "Kathgodam", "Doiwala", "Laksar", "Sahaspur", "Selaqui",
  ],
  "West Bengal": [
    "Kolkata", "Calcutta", "Howrah", "Asansol", "Siliguri", "Durgapur", "Bardhaman", "Burdwan",
    "English Bazar", "Malda", "Baharampur", "Berhampore", "Habra", "Kharagpur", "Shantipur", "Dankuni",
    "Ranaghat", "Haldia", "Raiganj", "Krishnanagar", "Nabadwip", "Medinipur", "Midnapore", "Jalpaiguri",
    "Balurghat", "Basirhat", "Bankura", "Chakdaha", "Darjeeling", "Alipurduar", "Purulia", "Jangipur",
    "Bangaon", "Cooch Behar", "Bolpur", "Santiniketan", "Kalyani", "Barasat", "Barrackpore",
    "Dum Dum", "Salt Lake", "Bidhannagar", "Rajarhat", "New Town", "Serampore", "Chandannagar",
    "Chinsurah", "Hooghly", "Uluberia", "Tamluk", "Contai", "Digha", "Kalimpong", "Kurseong",
    "Jhargram", "Arambagh", "Sainthia", "Suri", "Rampurhat", "Dubrajpur", "Katwa", "Kalna", "Memari",
    "Raghunathpur", "Bishnupur (West Bengal)", "Diamond Harbour", "Baruipur", "Sonarpur", "Garia",
    "Behala", "Madhyamgram", "Naihati", "Bhatpara", "Titagarh", "Panihati", "Khardaha", "Baranagar",
    "Kamarhati", "Budge Budge", "Maheshtala", "Rishra", "Konnagar", "Baidyabati", "Champdani",
    "Bansberia", "Gobardanga", "Dinhata", "Dhupguri", "Malbazar", "Gangarampur", "Islampur (West Bengal)",
    "Kaliaganj", "Chanchal", "Mathabhanga", "Falakata", "Birpara", "Mirik",
  ],
  "Delhi": [
    "Delhi", "New Delhi", "Dwarka", "Rohini", "Janakpuri", "Saket", "Karol Bagh", "Pitampura",
    "Laxmi Nagar", "Shahdara", "Narela", "Najafgarh", "Mehrauli", "Vasant Kunj", "Okhla",
  ],
  "Chandigarh": ["Chandigarh"],
  "Puducherry": ["Puducherry", "Pondicherry", "Karaikal", "Mahe", "Yanam", "Ozhukarai", "Villianur"],
  "Andaman & Nicobar": ["Port Blair", "Diglipur", "Mayabunder", "Car Nicobar", "Rangat", "Hut Bay"],
  "Ladakh": ["Leh", "Kargil"],
  "Lakshadweep": ["Kavaratti", "Agatti", "Minicoy"],
  "Dadra & Nagar Haveli and Daman & Diu": ["Silvassa", "Daman", "Diu", "Amli"],
};

// Some names repeat across states (Aurangabad, Bilaspur, Hamirpur, Srinagar, ...) and are
// written above with a "(State)" tag purely to keep this file readable. The tag is stripped
// here: the filter matches the typed text as a substring of the college's city column, so
// "Aurangabad (Bihar)" would match nothing — one plain "Aurangabad" entry is what works.
const seen = new Set();
const INDIAN_CITIES = [];
Object.values(CITIES_BY_REGION).forEach((cities) => {
  cities.forEach((raw) => {
    const name = raw.replace(/\s*\([^)]*\)\s*/g, " ").trim();
    const key = name.toLowerCase();
    if (!key || seen.has(key)) return;
    seen.add(key);
    INDIAN_CITIES.push(name);
  });
});
INDIAN_CITIES.sort((a, b) => a.localeCompare(b));

export default INDIAN_CITIES;
